//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LogoutHeader from "../../layouts/components/LogoutHeader.vue";
export default {
  components: {
    LogoutHeader: LogoutHeader
  },
  computed: {
    managedProviders: function managedProviders() {
      return this.$store.state.profile.managedProviders.data;
    }
  },
  methods: {
    selectProvider: function selectProvider(provider) {
      this.$store.dispatch("profile/SELECT_PROVIDER", provider.id);
    }
  },
  mounted: function mounted() {
    if (this.managedProviders.length === 1) {
      this.selectProvider(this.managedProviders[0]);
    }
  }
};